module.exports = __webpack_public_path__ + "img/golf_course.70f1fa0b.jpg";